import { Examples } from '@/types';

export const ExampleMStoreTableRoutes =
  process.env.NODE_ENV !== 'production'
    ? [
        {
          ...Examples.ExampleMStoreTable,
          components: {
            default: () =>
              import(
                /* webpackChunkName: "ExampleMStoreTableRoutes" */
                '@/views/examples/ExampleMStoreTable.vue'
              )
          }
        }
      ]
    : [];
